export default "__VITE_ASSET__DDkVeUJL__"